//import React from "react"
import React, { Component } from "react";
import AddIndustrialCertificateItems from "./AddIndustrialCertificateItems"; // import row item details
import axios from "axios";
import withRouter from "./withRouter";
import DatePicker from "../forms/DatePicker"; // import DatePicker
//import { withRouter } from "react-router-dom";
import Navbar from "../Navbar";
import { format } from "date-fns";
import swal from "sweetalert";
import { Link, useNavigate, useParams } from "react-router-dom";
import { id } from "date-fns/locale";

var month = new Date().getMonth() + 1;
// var month = "4";
var startdate = "2022-" + month + "-01";
if (month === "4" || month === "6" || month === "9" || month === "11") {
  var enddate = "2022-" + month + "-30";
} else if (month === "2") {
  var enddate = "2022-" + month + "-28";
} else {
  var enddate = "2022-" + month + "-31";
}

class AddIndustrialCertificate extends React.Component {
  // state define

  constructor(props) {
    super(props);
    this.state = {
      addMore: [
        {
          index: Math.random(),
          distin: "",
          sn: "",
          descriptive: "",
          test: "",
          pltonns: "",
          swltonns: "",
          swltonns2: "",
          constructDate: "",
        },
      ], //item list
      date: "",
      party_code: "",
      party_name: "",
      remarks: "",
      vertical_name: "",
      vertical_type: "",
      ship_name: "",
      lastlinedate:"",
      serial_type: "",
      address: "",
      associate_code: "",
      tested: "",
      user_id: localStorage.getItem("auth_id"),
      curr_challan_id: this.props.params.id,
      party_code_list: [],
      posts: [],
      series: [],
      fourth:"",
      fifth_a:"",
      fifth_b:"",
      fifth_c_one:"",
      fifth_c_two:"",
      sixth:"",
      error_list: [],
    };
  }

  // handle input changes
  handleChange = (e) => {
    if (
      ["distin", "sn", "descriptive", "test", "pltonns", "swltonns","swltonns2","constructDate"].includes(
        e.target.name
      )
    ) {
      let addMore = [...this.state.addMore];
      addMore[e.target.dataset.id][e.target.name] = e.target.value;
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  // party name populate using party code
  handlePartyCode = (e) => {
    const partyCode = e.target.value;
    axios.get(`/api/party_name/${partyCode}`).then((res) => {
      if (res.data.status === 200) {
        let PName = res.data.customer[0].name;
        this.setState({ party_name: PName });
        document.getElementById("party_name").value = PName;
      }
    });
  };

  // handle input changes
  handleChangeDate = (e) => {
    var dateToday = new Date();
    // console.log(dateToday)
  };

  //  Add new row Item details
  addNewRow = () => {
    this.setState((prevState) => ({
      addMore: [
        ...prevState.addMore,
        {
          index: Math.random(),
          distin: "",
          sn: "",
          descriptive: "",
          test: "",
          pltonns: "",
          swltonns: "",
          swltonns2: "",
          constructDate: "",
        },
      ],
    }));
  };

  componentDidMount() {
    // fetch("/api/view-customer") //local
      fetch('https://cert.geekay.biz/backend/api/view-customer').then(resp=>resp.json()) //Prod
      .then((resp) => this.setState({ posts: resp.customer }));

    axios.get(`/api/get_serial`).then((res) => {
      if (res.data.status === 200) {
        // console.log(res.data.itemDetails);
        this.setState({ series: res.data.series });
      }
    });

    // fetch('/api/get_serial').then(resp=>resp.json())
    // .then(resp=>this.setState({series:resp.series}))

    // console.log("fmasdk;fj;sdkf");
    // console.log(this.state.series);

    let id = this.props.params.id;

    axios.get(`/api/edit_challan/${id}`).then((res) => {
      if (res.data.status === 200) {
        // localStorage.setItem("c_id", id);

        this.setState(res.data.chalans);
        this.setState(res.data.chalanseqence);
        this.setState(res.data.pagetwodetails);
        this.setState({ addMore: res.data.itemDetails });
        console.log(this.state,"ali");
      }
    });
  }

  // update input action call backend Api and store data
  handleUpdate = (e) => {
    e.preventDefault();

    let data = this.state;
    // console.log(data);
    console.log(data,"ali");

    // let id  = this.props.params.id;
    axios.post(`/api/store_industrial_certificate`, data).then((res) => {
      if (res.data.status === 200) {
        console.log(data,"ali");
        document.getElementById("add_certificate").reset();
        localStorage.removeItem("challan_id");
        window.location.href = "/certificates/createcertificate";
      } else if (res.data.status === 500) {
        // console.log(data,"ali");
        this.setState({ ...this.state, error_list: res.data.errors });
      }
    });
  };

  //  delete addMore detals Row
  clickOnDelete(record) {
    this.setState({
      addMore: this.state.addMore.filter((r) => r !== record),
    });
  }

  // create form field data
  render() {
    //console.log('Props:', this.props)
    //console.log('Props:', this.props)
    //const { id } = this.props.match.params;
    //console.log('user=',user);
    let { addMore } = this.state; //collected data add more all field
    return (
      <div className="content">
        <Navbar />

        <form
          id="add_certificate"
          onSubmit={this.handleUpdate}
          onChange={this.handleChange}
        >
          <div className="row" style={{ marginTop: 20, width: "97%" }}>
            // <div className="col-sm-1"></div>
            <div className="col-sm-12" style={{ marginLeft: 40 }}>
              <div className="card">
                <div className="card-header">
                  <h4>
                    <b>Create Industrial Certificate</b>
                  </h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group ">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Verticle Name
                        </label>
                        <select
                          name="vertical_name"
                          id="vertical_name"
                          className="form-control"
                          value={this.state.vertical_name}
                        >
                          <option>--vertical_name --</option>
                          <option value="Industrial-MZ">Industrial-MZ</option>
                          <option value="Industrial-MA">Industrial-MA</option>
                          <option value="IDLR">IDLR</option>
                        </select>
                        <span style={{ color: "red" }}>
                          {this.state.error_list.vertical_name}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group ">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Party Code
                        </label>
                        <select
                          name="party_code"
                          id="party_code"
                          className="form-control"
                          value={this.state.party_code}
                          onChange={this.handlePartyCode}
                        >
                          <option value="">-- Party Code --</option>
                          {this.state.posts.map((post) => (
                            <option key={post.pcode}>
                              {post.pcode}
                              {post.title}
                            </option>
                          ))}
                        </select>
                        <span style={{ color: "red" }}>
                          {this.state.error_list.party_code}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group ">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Party Name
                        </label>
                        <input
                          type="taxt"
                          name="party_name"
                          id="party_name"
                          value={this.state.party_name}
                          className="form-control"
                          placeholder="Party Name"
                        />
                        <span style={{ color: "red" }}>
                          {this.state.error_list.party_name}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group ">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Associate Code
                        </label>
                        <input
                          type="taxt"
                          name="associate_code"
                          value={this.state.associate_code}
                          id="associate_code"
                          className="form-control"
                          placeholder="Associate Code"
                        />
                        <span style={{ color: "red" }}>
                          {this.state.error_list.associate_code}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group ">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Address
                        </label>
                        <input
                          type="taxt"
                          name="address"
                          id="address"
                          value={this.state.address}
                          className="form-control"
                          placeholder="Address"
                        />
                        <span style={{ color: "red" }}>
                          {this.state.error_list.address}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group ">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Date
                        </label>
                        {/* <input type="date"  name="date" id="date" className="form-control" placeholder="Enter Date" min={startdate} max={enddate}/> */}
                        <span
                          id="dataRemark"
                          style={{ color: "red", display: "none" }}
                          disabled={false}
                        >
                          Not open Month plz maintain Month master
                        </span>
                        {/* --------------------get month  ----------------*/}
                        <DatePicker date={this.datepicker} />
                        <span style={{ color: "red" }}>
                          {this.state.error_list.date}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Tested
                        </label>
                        <select
                          name="tested"
                          className="form-control"
                          value={this.state.tested}
                        >
                          <option>-- Select status --</option>
                          <option value="O.K">O.K</option>
                          <option value="Rejected">Rejected</option>
                        </select>
                        <span style={{ color: "red" }}>
                          {this.state.error_list.tested}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group ">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Remarks
                        </label>
                        <input
                          type="taxt"
                          name="remarks"
                          id="remarks"
                          value={this.state.remarks}
                          className="form-control"
                          placeholder="Enter Remarks"
                        />
                        <span style={{ color: "red" }}>
                          {this.state.error_list.remarks}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group ">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Series
                        </label>
                        <select
                          id="serial_type"
                          name="serial_type"
                          className="form-control"
                          value={this.state.serial_type}
                          onChange={this.handlePartyCode}
                        >
                          <option value="">-- Series Name --</option>
                          {this.state.series.map((post) => (
                            <option key={post.pcode}>{post.series_name}</option>
                          ))}
                        </select>
                        <span style={{ color: "red" }}>
                          {this.state.error_list.serial_type}
                        </span>
                      </div>
                    </div>
                    {/* <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group ">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Ship Name
                        </label>
                        <textarea
                          type="text"
                          name="ship_name"
                          id="ship_name"
                          value={this.state.ship_name}
                          className="form-control"
                          placeholder="Ship Name"
                        />
                        <span style={{ color: "red" }}>
                          {this.state.error_list.Ship_name}
                        </span>
                      </div>
                    </div> */}
                     <div className="col-sm-4" style={{ marginBottom: "15px" }}>
                      <div className="form-group ">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          Last Line Date
                        </label>
                        <input
                          type="text"
                          name="lastlinedate"
                          id="lastlinedate"
                          value={this.state.date}
                          className="form-control"
                          placeholder="Last Line Date"
                        />
                        <span style={{ color: "red" }}>
                          {this.state.error_list.Ship_name}
                        </span>
                      </div>
                    </div>
                    {/* <div className="col-sm-4">
                                            <div className="form-group ">
                                                <label className="required">Description</label>
                                                <textarea name="description"  id="description" className="form-control"></textarea>
                                            </div>
                                        </div> */}
                  </div>

                  {/* --------------------Item details Add more Display data Start ----------------*/}
                  <table
                    class="table table-bordered"
                    style={{ marginTop: "30px" }}
                  >
                    <thead>
                      <tr>
                        <th scope="col" style={{ width: "15%" }}>
                          Category
                        </th>
                        <th scope="col" style={{ width: "13%" }}>
                          Distinguish Mark
                        </th>
                        {/* <th scope="col" style={{ width: "4%" }}>
                          S N
                        </th> */}
                        <th scope="col" style={{ width: "27%" }}>
                          Description/Dimension & Material of Gear/Device
                        </th>
                        <th scope="col" style={{ width: "8%" }}>
                          Nos. Tests
                        </th>
                        <th scope="col" style={{ width: "8%" }}>
                          P.L. Tonns
                        </th>
                        <th scope="col" style={{ width: "10%" }}>
                          SWL Tonns
                        </th>
                        <th scope="col" style={{ width: "5%" }} >SWL Select</th>
                        <th scope="col" style={{ width: "10%" }}>
                          Date of Construction
                        </th>
                        <th scope="col" style={{ width: "2%" }}>
                          #
                        </th>
                      </tr>
                    </thead>
                    {/* -------------------- Create Add and Delete both Functions Delete row and Add row  ----------------*/}
                    <tbody>
                      <AddIndustrialCertificateItems
                        add={this.addNewRow}
                        delete={this.clickOnDelete.bind(this)}
                        addMore={addMore}
                      />
                    </tbody>
                  </table>
                  {/* --------------------Item details Add more Display data End ----------------*/}
                </div>
                <div  style={{ marginBottom: "15px",marginLeft: 20 }}>
                      <div className="row" style={{ marginBottom: "25px"}}>
                      <div className="col-sm-8">
                        <span
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          4) Date of last examinations made under section 29(1)(a)(iii) and by whom it was carried out.
                        </span>
                        </div>
                        <div className="col-sm-3">
                        <textarea
                          type="text"
                          name="fourth"
                          id="fourth"
                          value={this.state.fourth}
                          className="form-control"
                          placeholder="Ship Name"
                        />
                        </div>
                      </div>
                      <div className="row"  style={{ marginBottom: "25px"}}>
                      <div className="col-sm-8">
                        <span
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          5) (A) Maintenance (List of parts,if any, which were inacessible)
                          Are the following parts of the hoist ort lift properly maintained and in good working order? If not, state what defects have been found.<br/>
                          (a) Enclosure of hoistway or liftway.<br/>
                          (b) Landing gates and cage gate(s).<br/>
                          (c) Interlocks on the landing gates and age gate(s).<br/>
                          (d) Other gate fastenings.<br/>
                          (e) Cage and platform amd fittings, cage guides, buffers, interior of the hoistway or liftway.<br/>
                          (f) Overrunning devices<br/>
                          (g) Suspension ropes or chains and their attachments<br/>
                          (h) Safety gear, i.e. arrangements for preventing fall of platform or cage brakes.<br/>
                          (i) Brakes<br/>
                          (j) Work of spur gearing<br/>
                          (k) Other electrical equipment.<br/>
                          (l) Other parts<br/>
                         </span>
                         </div>
                         <div className="col-sm-3"  style={{ marginTop: "125px"}}>
                        <textarea
                          type="text"
                          name="fifth_a"
                          id="fifth_a"
                          value={this.state.fifth_a}
                          className="form-control"
                          placeholder="Ship Name"
                        />
                        </div>
                      </div>
                      <div className="row"  style={{ marginBottom: "25px"}}>
                      <div className="col-sm-8">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          5(B) Date and number of the certificate relating to any test and examination made under sub- rule(1) of rule 64 together with the name of the person who issued the certificate.
                        </label>
                        </div>
                        <div className="col-sm-3">
                        <textarea
                          type="text"
                          name="fifth_b"
                          id="fifth_b"
                          value={this.state.fifth_b}
                          className="form-control"
                          placeholder=""
                        />
                        </div>
                      </div>
                      <div className="row"  style={{ marginBottom: "25px"}}>
                      <div className="col-sm-8">
                        <label
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          5(C) (i)Date of annealing or their heat treatment of the chain and lifting tackle carried out under sub-rule(5) of rule 64 and by whom it was carried out.
                         </label>
                         </div>
                         <div className="col-sm-3">
                        <textarea
                          type="text"
                          name="fifth_c_one"
                          id="fifth_c_one"
                          value={this.state.fifth_c_one}
                          className="form-control"
                          placeholder="Ship Name"
                        />
                        </div>
                      </div>
                      <div className="row"  style={{ marginBottom: "25px"}}>
                        <div className="col-sm-8">
                        <span
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          5(C) (ii)Particulars of any defect found at any such examination or after annealing and affecting the safe working load and of the steps taken to remedy such defect.
                        </span>
                        </div>
                        <div className="col-sm-3">
                        <textarea
                          type="text"
                          name="fifth_c_two"
                          id="fifth_c_two"
                          value={this.state.fifth_c_two}
                          className="form-control"
                          placeholder="Ship Name"
                        />
                        </div>
                      </div>
                      <div className="row"  style={{ marginBottom: "25px"}}>
                      <div className="col-sm-8">
                        <span
                          className="required"
                          style={{ marginBottom: "7px" }}
                        >
                          6) Repairs, renewals or alterations (if any) required and the period within which they should be executed and maximum safe working load subject to repairs, renewals or alterations(if any)
                        </span>
                        </div>
                        <div className="col-sm-3">
                        <textarea
                          type="text"
                          name="sixth"
                          id="sixth"
                          value={this.state.sixth}
                          className="form-control"
                          placeholder="Ship Name"
                        />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-sm-4">
                                            <div className="form-group ">
                                                <label className="required">Description</label>
                                                <textarea name="description"  id="description" className="form-control"></textarea>
                                            </div>
                                        </div> */}
             
                <div className="card-footer text-center">
                  {" "}
                  <button
                    id="update"
                    type="Update"
                    style={{ backgroundColor: "#A38A00", color: "white" }}
                    className="btn btn-default text-center"
                    disabled={false}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
            // <div className="col-sm-1"></div>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(AddIndustrialCertificate);
//export default UpdateChallanDetails;
